import { Button, Paper, styled } from "@mui/material";
import { Form } from "formik";


export const StyledServiceMonitorSearchForm = {
  StyledPaper: styled(Paper)({
    display: "flex",
    padding: 20,
    marginBottom: 20,
  }),
  StyledInput: styled("span")({
    marginRight: 20,
    width: 250,
  }),
  ButtonContainer: styled("span")({
    justifyContent: "flex-end",
  }),
  StyledButton: styled(Button)(({ theme }) => ({
    margin: theme.spacing(1),
  })),
  StyledForm: styled(Form)({
    display: "flex",
  }),
};
